export const REACT_APP_API_ENDPOINT = 'https://api.ws-com.red.com.pl';
export const REACT_APP_GPWAPI_ENDPOINT = 'http://gpw-gateway.ws-com.red.com.pl';
export const REACT_APP_FORMSAPI_ENDPOINT = 'http://forms-api.ws-com.red.com.pl';
export const MS_AZURE_ENDPOINT = 'https://prod-39.westeurope.logic.azure.com:443/workflows/4bad8b19393b4df795831e6abafc85d5/triggers/manual/paths/invoke?api-version=2016-10-01&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=Li-8XOXIdVTvqw8mQqOSjzTD1p2O-u_RHCHgEGTyoc8';



// WEBPACK FOOTER //
// ./src/endpoints.js